import React from "react"

const Globe = ({ className }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="80"
		height="80"
		viewBox="0 0 80 80"
		className={`inline-block align-middle fill-current ${className || ""}`}>
		<path
			d="M41.85 76.188c18.268 0 33.077-14.809 33.077-33.077S60.117 10.034 41.85 10.034c-18.268 0-33.077 14.81-33.077 33.077 0 18.268 14.81 33.077 33.077 33.077z"
			fill="#FFFFFF"
		/>
		<path
			d="M41.85 76.188c18.268 0 33.077-14.809 33.077-33.077S60.117 10.034 41.85 10.034c-18.268 0-33.077 14.81-33.077 33.077 0 18.268 14.81 33.077 33.077 33.077z"
			opacity="0.3"
		/>
		<path d="M40 3.077c20.392 0 36.923 16.53 36.923 36.923 0 20.392-16.53 36.923-36.923 36.923-20.392 0-36.923-16.53-36.923-36.923C3.077 19.608 19.607 3.077 40 3.077zM7.707 29.834A33.832 33.832 0 006.154 40c0 16.591 11.937 30.394 27.692 33.288v-7.134a4.615 4.615 0 01-4.615-4.616v-9.233L7.707 29.835zm39.998-22.8v4.815c0 3.399-2.368 6.616-5.766 6.616h-8.093v6.691c0 3.399-2.654 5.618-6.053 5.618H24.65V40h17.29c3.398 0 5.767 2.832 5.767 6.23v10.693h5.922c3.398 0 6.376 2.775 6.376 6.174v4.207a33.936 33.936 0 0011.808-15.72A17.985 17.985 0 0167.7 40.676l-.009-.547v-.403c0-4.114 1.49-8.075 4.171-11.161a33.894 33.894 0 00-10.599-14.899.767.767 0 01-.495.18H58.37v.775a.77.77 0 01-.77.769h-2.215v-2.313a.77.77 0 01.769-.77h2.308l.001-.679a33.66 33.66 0 00-10.758-4.593zM67.692 50.77v1.539h-1.538v-1.539h1.538zM12.308 38.462V40h-1.539v-1.538h1.539zm20.769-6.154a.77.77 0 01.757.63l.012.139v.77h2.308a.77.77 0 01.757.63l.012.138v2.313h-2.216a.77.77 0 01-.757-.63l-.012-.139v-.774h-2.4a.77.77 0 01-.756-.631l-.013-.139v-2.307h2.308zM40 35.385v1.538h-1.538v-1.538H40z" />
	</svg>
)

export default Globe
